import { render, staticRenderFns } from "./ContainedButton.vue?vue&type=template&id=05d33867&scoped=true&"
import script from "./ContainedButton.vue?vue&type=script&lang=js&"
export * from "./ContainedButton.vue?vue&type=script&lang=js&"
import style0 from "./ContainedButton.vue?vue&type=style&index=0&id=05d33867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d33867",
  null
  
)

export default component.exports